export const SESSION_KEY_NAME = {
    MAIN: {
        lang: 'lang'
    },
    WORKOS: {
        session_id: 'workos:session-id',
        previous_session_login_hint: 'workos:previous-session-login-hint',
    },
}